<template>
  <main class="container solution-dualcare">
    <section ref="sectionRef" class="wellcome-section">
      <button class="btn outline">Air Sterilizing Purifier</button>
      <h1>Remove Fine Dust and Viruses at once!</h1>
      <p>
        Initiates a new air care concept by combining two engines in one unit to combat airborne fine dust and viruses infiltrating the respiratory
        system.
      </p>

      <router-link to="/contact/mail/send?local=eng">
        <p ref="buttonRef" id="applyButton" :class="[buttonClass, buttonHiddenClass]">Send Email</p>
      </router-link>
    </section>

    <img
      :src="require(`@/assets/images/solution/dualcare/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [Solution] Air Sterilizing Purifier"
    />

    <section class="airborne-virus flex-swiper">
      <div>
        <h3 class="title-section">
          Removes 99.99% of <br class="mo_show" />
          Ultra-Fine Dust and <br />
          99.98% of Airborne Viruses
        </h3>
      </div>

      <swiper :slides-per-view="'auto'" class="dualcare-swiper">
        <swiper-slide class="card-dual-care">
          <img src="@/assets/images/solution/dualcare/card_dual_care_01.png" />
          <p>Dualcare Purification + Sterilization</p>
        </swiper-slide>
        <swiper-slide class="card-dual-care">
          <img src="@/assets/images/solution/dualcare/card_dual_care_02.png" />
          <p>Eliminates Airborne Viruses</p>
        </swiper-slide>
        <swiper-slide class="card-dual-care">
          <img src="@/assets/images/solution/dualcare/card_dual_care_03.png" />
          <p>Removes Airborne Bacteria</p>
        </swiper-slide>
        <swiper-slide class="card-dual-care">
          <img src="@/assets/images/solution/dualcare/card_dual_care_04.png" />
          <p>Employs a Powerful H14 Filter for Effective Purification</p>
        </swiper-slide>
        <swiper-slide class="card-dual-care">
          <img src="@/assets/images/solution/dualcare/card_dual_care_05.png" />
          <p>CESCO Science UV Sterilization Tunnel</p>
        </swiper-slide>
        <swiper-slide class="card-dual-care">
          <img src="@/assets/images/solution/dualcare/card_dual_care_06.png" />
          <p>UV-C Sterilization Lamp Disrupts Virus DNA</p>
        </swiper-slide>
        <swiper-slide class="card-dual-care">
          <img src="@/assets/images/solution/dualcare/card_dual_care_07.png" />
          <p>
            Design with an <br class="mo_show" />
            S-shaped Flow Maximizes <br class="mo_show" />
            Sterilization Time
          </p>
        </swiper-slide>
        <swiper-slide class="card-dual-care">
          <img src="@/assets/images/solution/dualcare/card_dual_care_08.png" />
          <p>Mirror Wall Design Enhances Sterilization Effectiveness</p>
        </swiper-slide>
      </swiper>
    </section>

    <section class="section aircare-concept">
      <div class="contents-center">
        <h3 class="title-section center">Introducing a Revolutionary Air Care Concept</h3>

        <div class="layout-j">
          <div class="layout-j-content">
            <h4>Why did CESCO create an air sterilizer purifier?</h4>
            <p>
              In response to simultaneous fine dust and virus threats, CESCO combines purification with sterilization, launching the new era of air
              care with DualCare.
            </p>
          </div>
          <div class="layout-j-content">
            <img src="@/assets/images/solution/dualcare/gif_1.gif" alt="CESCO [Solution] Air Sterilizing Purifier" />
          </div>
          <div class="layout-j-content">
            <img src="@/assets/images/solution/dualcare/gif_2.gif" alt="CESCO [Solution] Air Sterilizing Purifier" />
          </div>
          <div class="layout-j-content">
            <h4>Our fine dust cleaning engine removes 99.99% of airborne fine dust</h4>
            <ul class="list-i">
              <li>Removes 99.99% of ultra-fine dust</li>
              <li>Features five types of ultra-precision sensors</li>
              <li>Includes an air quality LED indicator</li>
              <li>Manages air quality around the clock</li>
            </ul>
          </div>
          <div class="layout-j-content">
            <h4>Virus sterilization engine effectively kills 99.98% of viruses</h4>
            <ul class="list-i">
              <li>Preemptive Virus Attack System™</li>
              <li>UV Sterilization Tunnel™ removes 99.98% of influenza viruses</li>
              <li>Allows selection between sterilization or purification modes based on the situation</li>
              <li>Features smart operation with turbo sterilization mode</li>
              <li>Result of joint research with Korea University Virus Disease Research Institute</li>
            </ul>
          </div>
          <div class="layout-j-content">
            <img src="@/assets/images/solution/dualcare/gif_3.gif" alt="CESCO [Solution] Air Sterilizing Purifier" />
          </div>
        </div>
      </div>
    </section>

    <section class="section what-different">
      <div class="contents-center">
        <h3 class="title-section">What Differentiates the Air Sterilizer Purifier of CESCO?</h3>

        <div class="card-type-j">
          <div class="card">
            <img
              :src="require(`@/assets/images/solution/dualcare/card_j_01${mobileCheck ? '_mo' : ''}.png`)"
              alt="CESCO [Solution] Air Sterilizing Purifier"
            />
            <div>
              <div v-if="!mobileCheck" class="top-box">
                <h4>Sterilize air directly! A unique approach to sterilization.</h4>
                <p>
                  The CESCO air sterilizer purifier operates using the UV Sterilization Tunnel™ method, which directly sterilizes the air, setting it
                  apart from filter-based methods
                </p>
              </div>
              <div v-else class="top-box">
                <h4>Why did CESCO create an air sterilizer purifier?</h4>
                <p>
                  In response to simultaneous fine dust and virus threats, CESCO combines purification with sterilization, launching the new era of
                  air care with DualCare.
                </p>
              </div>
              <div class="bottom-box">
                <div>
                  <div class="highlight-gray">Filter Sterilization Method</div>
                  <ul>
                    <li>Method for sterilizing the surface of the air purifier filter</li>
                    <li>
                      UV-A used, which does not provide sterilization effects <br class="mo_show" />
                      (Korea Consumer Agency / 2020 Ultraviolet Sterilizer Survey)
                    </li>

                    <li>High likelihood of bacteria and viruses remaining on the filter</li>
                  </ul>
                </div>

                <div>
                  <div class="highlight-blue">UV Sterilization Tunnel <span class="tm">™</span>&nbsp; method</div>
                  <ul>
                    <li>Method for directly sterilizing air by drawing it in</li>
                    <li>Most powerful UV-C germicidal lamps used for destroying viruses and bacteria</li>
                    <li>UV-C ultraviolet light destroys the genetic material of bacteria and viruses, preventing resistance</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <img
              :src="require(`@/assets/images/solution/dualcare/card_j_03${mobileCheck ? '_mo' : ''}.png`)"
              alt="CESCO [Solution] Air Sterilizing Purifier"
            />
            <div>
              <div class="top-box">
                <h4>The UV Sterilization Tunnel features unique design science.</h4>
                <p>
                  Equipped with CESCO's special air sterilization module, the UV Sterilization Tunnel™ destroys virus DNA, ensuring both safety and
                  efficacy.
                </p>
              </div>
            </div>
          </div>

          <div class="card">
            <img
              :src="require(`@/assets/images/solution/dualcare/card_j_04${mobileCheck ? '_mo' : ''}.png`)"
              alt="CESCO [Solution] Air Sterilizing Purifier"
            />
            <div>
              <div class="top-box">
                <h4>CESCO adheres to rigorous standards for safety and trust.</h4>
                <p>
                  The CESCO Science Research Institute, in collaboration with the Korea University Medical School Virus Disease Research Institute,
                  has rigorously tested and verified the sterilization effectiveness through joint research and certified testing agencies.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section cleaning-engine">
      <div class="contents-center">
        <h3 class="title-section center">Fine Dust Cleaning Engine, Virus Sterilization Engine</h3>
        <p class="description-section center">
          The two engines can operate independently as an air purifier when fine dust is a concern and as <br class="pc_show" />
          an air sterilizer when viruses and bacteria are a concern, or they can operate simultaneously.
        </p>

        <div class="layout-area">
          <h4>Fine Dust Cleaning Engine</h4>

          <div class="layout-j">
            <div class="layout-j-content">
              <h4>Removes 99.9% of Ultrafine Particles</h4>
              <p>
                Features a high-performance H14 filter in a four-stage filtering system to powerfully purify fine dust and volatile organic compounds.
              </p>
              <img
                :src="require(`@/assets/images/solution/dualcare/layout_j_01${mobileCheck ? '_mo' : ''}.png`)"
                alt="CESCO [Solution] Air Sterilizing Purifier"
              />
            </div>
            <div class="layout-j-content">
              <h4>Ultra-precision Air Quality Sensor</h4>
              <p>DualCare, equipped with ultra-precision sensors, automatically detects and purifies air quality.</p>
              <img
                :src="require(`@/assets/images/solution/dualcare/layout_j_02${mobileCheck ? '_mo' : ''}.png`)"
                alt="CESCO [Solution] Air Sterilizing Purifier"
              />
            </div>

            <div class="layout-j-content">
              <h4>Indoor & Outdoor Air Quality Indicator Lights</h4>
              <p>The air purifier changes color to monitor both indoor and outdoor air quality.</p>
              <img
                :src="require(`@/assets/images/solution/dualcare/layout_j_03${mobileCheck ? '_mo' : ''}.png`)"
                alt="CESCO [Solution] Air Sterilizing Purifier"
              />
            </div>
            <div class="layout-j-content">
              <h4>Manages Air Quality Around The Clock.</h4>
              <p>
                The optimal ventilation timing alarm is standard, and the CESCO Integrated Situation Room analyzes air quality data to provide
                reports.
              </p>
              <img
                :src="require(`@/assets/images/solution/dualcare/layout_j_04${mobileCheck ? '_mo' : ''}.png`)"
                alt="CESCO [Solution] Air Sterilizing Purifier"
              />
            </div>
          </div>
        </div>

        <div class="layout-area">
          <h4>Preemptive Virus Attack Engine</h4>

          <div class="layout-j">
            <div class="layout-j-content">
              <h4>Maximizes Sterilization Effectiveness</h4>
              <p>Enhances the level of air sterilization through the UV Sterilization Tunnel.</p>
              <div class="img-box">
                <div>
                  <img src="@/assets/images/solution/dualcare/uvc_lamp.png" alt="CESCO [Solution] Air Sterilizing Purifier" />
                  <div>
                    <h5>
                      UV-C<br />
                      Germicidal Lamp
                    </h5>
                    <p>Completely destroys the genetic material of viruses</p>
                  </div>
                </div>
                <div>
                  <img src="@/assets/images/solution/dualcare/s_curve.png" alt="CESCO [Solution] Air Sterilizing Purifier" />
                  <div>
                    <h5>S-shaped Flow Design</h5>
                    <p>Prolongs the passage time through the sterilization tunnel, sustaining sterilization power</p>
                  </div>
                </div>
                <div>
                  <img src="@/assets/images/solution/dualcare/mirror_wall.png" alt="CESCO [Solution] Air Sterilizing Purifier" />
                  <div>
                    <h5>Mirror Wall Design</h5>
                    <p>Maximizes sterilization power through the mirror reflection effect</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="layout-j-content">
              <h4>
                Turbo Sterilization<br />
                Mode
              </h4>
              <p>Smart Operation Turbo Sterilization Mode' automatically detects contamination levels and activates the sterilization mode.</p>
              <img
                :src="require(`@/assets/images/solution/dualcare/layout_j_05${mobileCheck ? '_mo' : ''}.png`)"
                alt="CESCO [Solution] Air Sterilizing Purifier"
              />
            </div>
            <div class="layout-j-content">
              <h4>
                Sterilization / <br />
                Purification Mode
              </h4>
              <p>
                On days with significant fine dust, the air purifier operates; when viruses are a concern, the preemptive virus attack system is
                activated.
              </p>
              <img
                :src="require(`@/assets/images/solution/dualcare/layout_j_06${mobileCheck ? '_mo' : ''}.png`)"
                alt="CESCO [Solution] Air Sterilizing Purifier"
              />
            </div>
            <div class="layout-j-content">
              <h4>
                Preemptive Attack <br />
                System
              </h4>
              <p>Filters airborne dust and releases air that has been sterilized from viruses and bacteria.</p>
              <img
                :src="require(`@/assets/images/solution/dualcare/layout_j_07${mobileCheck ? '_mo' : ''}.png`)"
                alt="CESCO [Solution] Air Sterilizing Purifier"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section regular-maintenance">
      <div class="contents-center">
        <div class="regular-maintenance-info">
          <h3 class="title-section">
            Professional &
            <br />
            Regular Maintenance
          </h3>

          <p class="description-section">A professional, extensively trained by CESCO, systematically manages DualCare.</p>
        </div>
        <div class="regular-maintenance-causes">
          <div class="cause-item">
            <img src="@/assets/images/icons/banner_cesco_dualcare_ico01 1.svg" />
            <div>
              <h4 class="title">
                Regular Maintenance of
                <br class="pc_show" />
                Filters
              </h4>
              <p class="label">Replacement of pre-filters, custom filters, deodorizing filters, HEPA filters, and carbon cover filters</p>
            </div>
          </div>
          <div class="cause-item">
            <img src="@/assets/images/icons/banner_cesco_dualcare_ico01 2.svg" />
            <div>
              <h4 class="title">UV-C Sterilization Lamp Replacement</h4>
              <p class="label">Regular lamp maintenance ensures effective virus and bacteria elimination.</p>
            </div>
          </div>
          <div class="cause-item">
            <img src="@/assets/images/icons/banner_cesco_dualcare_ico01 3.svg" />
            <div>
              <h4 class="title">DualCare Device Management</h4>
              <p class="label">Manages sensor operation and controls airflow, lighting, and mode settings</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section ref="checkSectionRef" class="sub-footer">
      <h2>
        A revolutionary <br class="mo_show" />
        approach to air care <br class="mo_show" />
        that <br class="pc_show" />
        addresses both fine dust and
        <br class="pc_show" />
        viruses simultaneously.
      </h2>
      <p>Discover an unprecedented new concept in air care.</p>

      <router-link to="/contact/mail/send?local=eng" class="btn"> Send Email </router-link>
    </section>
  </main>
</template>

<script setup>
import { inject } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useMeta } from 'vue-meta'
import { useScroll } from '@/hooks'

const { sectionRef, checkSectionRef, buttonRef, buttonClass, buttonHiddenClass } = useScroll()

const mobileCheck = inject('mobileCheck')

useMeta({
  title: 'CESCO - Air Sterilizing Purifier',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: 'Remove Fine Dust and Viruses at once!'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/dualcare.scss';
</style>
